'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-6a5a8a7f.js');
var React = require('react');
var context = require('@amzn/stencil-react-components/context');
var form = require('@amzn/stencil-react-components/form');
var layout = require('@amzn/stencil-react-components/layout');
var text = require('@amzn/stencil-react-components/text');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _templateObject;

var _excluded = ["className", "warning", "error"];
var Checkbox = function Checkbox(_ref) {
  var className = _ref.className,
      warning = _ref.warning,
      error = _ref.error,
      rest = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default["default"].createElement(CheckboxContainer, {
    className: className,
    warning: warning,
    error: error
  }, /*#__PURE__*/React__default["default"].createElement(layout.Row, {
    alignItems: 'center',
    gridGap: 'S200'
  }, /*#__PURE__*/React__default["default"].createElement(form.Checkbox, _rollupPluginBabelHelpers._objectSpread2({}, rest)), (rest === null || rest === void 0 ? void 0 : rest.id) && (rest === null || rest === void 0 ? void 0 : rest.title) && /*#__PURE__*/React__default["default"].createElement(text.Label, {
    htmlFor: rest.id
  }, rest.title)));
};
var CheckboxContainer = context.styledWithTheme('div')(_templateObject || (_templateObject = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n    input ~ div {\n        ", "\n        ", "\n    }\n"])), function (_ref2) {
  var warning = _ref2.warning,
      theme = _ref2.theme;
  return warning && "\n            border-color: ".concat(theme.selectors.color('yellow70'), ";\n        ");
}, function (_ref3) {
  var error = _ref3.error,
      theme = _ref3.theme;
  return error && "\n            border-color: ".concat(theme.selectors.color('red70'), ";\n        ");
});

exports.Checkbox = Checkbox;
//# sourceMappingURL=checkbox-6df60258.js.map
